import axiosInstance from "./axiosInstance";

export const getAllSales = (archived = false) =>
    axiosInstance.get(`/Sales/GetAllSales?archived=${archived}`);

export const getAllSalesByAgentId = (agentId, archived = false) =>
    axiosInstance.get(`/Sales/GetAllSalesByAgentId?agentId=${agentId}&archived=${archived}`);

export const getAllSalesByGroupName = (groupName, archived = false) =>
    // encodeURIComponent so group names with special chars (e.g. "Don & Alice")
    // don't break the query string — the '&' was being read as a param separator.
    axiosInstance.get(`/Sales/GetAllSalesByGroupName?groupName=${encodeURIComponent(groupName)}&archived=${archived}`);

export const getTotalFinalPriceByGroupLast30Days = () =>
    axiosInstance.get("/Sales/GetTotalFinalPriceByGroupLast30Days");

export const createSales = (salesData) =>
    axiosInstance.post("/Sales/CreateSales", salesData);

export const getSalesLineItems = (salesId) =>
    axiosInstance.get(`/Sales/GetSalesLineItems?salesId=${salesId}`);

export const updateSalesByAdmin = (salesData) =>
    axiosInstance.put("/Sales/UpdateSalesByAdmin", salesData);

// Project Timeline milestone update (admin / group-admin). Sends the 6 manual dates.
export const updateSalesTimeline = (payload) =>
    axiosInstance.put("/Sales/UpdateSalesTimeline", payload);

export const importHistoricalSales = (salesData) =>
    axiosInstance.post("/Sales/ImportHistoricalSales", { sales: salesData }, { timeout: 300000 });

export const getTopAgents = (month, year) =>
    axiosInstance.get(`/Sales/GetTopAgents?month=${month}&year=${year}`);

// Hall of fame — each agent's best single-month revenue, all-time (top 10).
export const getBestMonthlySales = () =>
    axiosInstance.get("/Sales/GetBestMonthlySales");

export const getRecentSales = (limit = 10) =>
    axiosInstance.get(`/Sales/GetRecentSales?limit=${limit}`);

export const getCompanyGoalTotal = (year = 2026) =>
    axiosInstance.get(`/Sales/GetCompanyGoalTotal?year=${year}`);

export const getSalesById = (salesId) =>
    axiosInstance.get(`/Sales/GetSalesById?salesId=${salesId}`);

export const archiveSale = (salesId) =>
    axiosInstance.put(`/Sales/ArchiveSale?salesId=${salesId}`);

export const getSalesDocuments = (salesId) =>
    axiosInstance.get(`/Sales/GetSalesDocuments?salesId=${salesId}`);

export const uploadSalesDocument = (formData) =>
    axiosInstance.post('/Sales/UploadSalesDocument', formData, { headers: { 'Content-Type': 'multipart/form-data' } });

export const deleteSalesDocument = (salesDocumentId) =>
    axiosInstance.delete(`/Sales/DeleteSalesDocument?salesDocumentId=${salesDocumentId}`);

// types: optional array of form types to regenerate (e.g. ['quotation']); omit for the full set.
export const generateSaleForms = (salesId, signed = false, types = null) => {
    const t = Array.isArray(types) && types.length ? `&types=${encodeURIComponent(types.join(','))}` : '';
    return axiosInstance.post(`/Sales/GenerateSaleForms?salesId=${salesId}&signed=${signed}${t}`);
};

export const generateSignLink = (salesId) =>
    axiosInstance.post(`/Sales/GenerateSignLink?salesId=${salesId}`);

// Possible-duplicate check for the create forms (WARN-only, never blocks save).
export const checkDuplicateSale = ({ name, phone, ic, excludeSalesId } = {}) =>
    axiosInstance.post('/Sales/CheckDuplicateSale', {
        name: name || null,
        phone: phone || null,
        ic: ic || null,
        excludeSalesId: excludeSalesId ?? null,
    });